
import Status from "../../../assets/filled/Status.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function StatusIcon({ className, dataTestid = "StatusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Status data-testid={dataTestid} className={classes} {...rest} />
  );
}
